import { render, staticRenderFns } from "./RecommendJobList.vue?vue&type=template&id=4a1a6b5f&scoped=true"
import script from "./RecommendJobList.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecommendJobList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RecommendJobList.vue?vue&type=style&index=0&id=4a1a6b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a6b5f",
  null
  
)

export default component.exports